import './contacts-content.scss'

export default {
    name: 'contacts-content',

    mounted () {
        this.googleMap()

        let radioIndex = sessionStorage.getItem('contactFormIndex');
        if (radioIndex) {
            radioIndex = parseInt(radioIndex) - 1
            sessionStorage.removeItem('contactFormIndex')
            const radios = this.$el.querySelectorAll('.communication-type input[type="radio"]')
            if (radios.length && radios[radioIndex]) {
                radios[radioIndex].checked = true
            }
        }
    },

    methods: {
        googleMap() {
            if (!window.google) {
                setTimeout(() => this.googleMap(), 1000)
                return
            }

            const position = {
                lat: parseFloat(this.position.lat),
                lng: parseFloat(this.position.lng)
            }

            this.map = new google.maps.Map(this.$refs.map, {
                center: position,
                zoom: 12,
                styles: [
                    {
                        "featureType": "administrative",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#6195a0"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#e6f3d6"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "all",
                        "stylers": [
                            {
                                "saturation": -100
                            },
                            {
                                "lightness": 45
                            },
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#f4d2c5"
                            },
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "color": "#4e4e4e"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#f4f4f4"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#787878"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#eaf6f8"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#eaf6f8"
                            }
                        ]
                    }
                ]
            })

            const icon = {
                url: window.__themeUrl + '/assets/img/marker.png',
                scaledSize: {
                    width: 150,
                    height: 169
                }
            }

            new google.maps.Marker({
                position,
                map: this.map,
                icon
            })
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/contacts-content/contacts-content.js